import { datadogRum } from '@datadog/browser-rum';
import { Locale } from '@smg-real-estate/geo-libs';
import flatMap from 'lodash.flatmap';

import { findGeoLocations } from '@/api/geoService';
import convertToSelectableZipAndCityItems from './convertToSelectableZipAndCityItems';
import type { SelectableZipAndCity } from './types';

const searchGeoLocations = async (
  query: string,
  language: string,
  size = 10,
): Promise<SelectableZipAndCity[]> => {
  try {
    const geoLocations = await findGeoLocations({
      language,
      query,
      types: 'zip',
      size,
    });

    return flatMap(geoLocations, (resultItem) =>
      convertToSelectableZipAndCityItems(resultItem, language as Locale),
    );
  } catch (error) {
    datadogRum.addError(error);

    return [];
  }
};

export { searchGeoLocations };
